import type { CSSProperties } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import "./Placeholder.linaria.module.css!=!./Placeholder?./Placeholder.linaria.module.css?css=H4sIAAAAAAAAA5VRQW7jMAy85xW6FGgOCmKvXaDOpT8RFIu2WUuiKsl2DSF/L5w42aS7PZQnzZAcjsi3HubGSwOBtR4Vd1rW0JFW4LkbdACWNmyN/dMdWIKcrDHOFcsON/50e5U/1+93xf86sv0vRpw2OxmNyJVwcyim8RGlo6z71tNgFa9Jk69G6Z85v6M1tl3krZczz7eHVc6JgUqt+yQtGhmRbPXDXvLAQAbgaDkNke13ZWBoG7QY4XDavBlQKNmz89CAD9yDGmpQ3NBZlF3wNp2nQu4ymkSr56kx/zJ3ZixZOJxWs9KL7OgK6utvMDUaPrlCD/W5qyY9GHv942sQWfyccNRJYXBaztVSf01DLjIKH5SPqYNlR9Vyl2t2nG/ZCVXsHpLlu8jmoiDdpCP5ZVdeKhxCVbgHedWXHyiv8pfLXMDtEN0fkTnTDy/hG0xG+hYtj+TWzr/E9t6l9U1Eubp8OZv8AhA47E3uAgAA"
// one pulse shared by the image block and the name bar so a row of
// placeholders breathes together; reduced-motion users get static blocks
// (the Explore video avatar shelf's placeholders pulse with it)
export const pulseStyles = "atm_2d_pys4wv atm_p_uo5llk atm_e2p1ow_glywfm";
const rootStyles = "atm_ar_1bp4okc atm_9s_1txwivl atm_e2_1osqo2v atm_vy_1osqo2v";
const imageStyles = "atm_5j_1y44olf atm_e2_1dk5qia atm_vy_1osqo2v";
const nameStyles = "atm_5j_1y44olf atm_h3_1pmku6s atm_e2_1dk5qia atm_vy_1nrftia";
type PlaceholderProps = {
  /** image area height; 0 for the text and list displays */
  displayHeight: number;
  /** full tile height: the row height minus the grid padding */
  tileHeight: number;
};

/**
 * Inert stand-in for a grid tile that has no model yet: the image block and
 * a short name bar, sized from the same numbers as the real tile so the
 * rows keep their height when the live list replaces it. Not focusable, not
 * clickable, hidden from assistive tech.
 */
const Placeholder = memo((props: PlaceholderProps) => {
  const {
    displayHeight,
    tileHeight
  } = props;
  const nameArea = tileHeight - displayHeight;
  return <div data-testid="ModelTile__Placeholder" className={rootStyles} aria-hidden>
            {displayHeight > 0 && <div style={{
      '--height': displayHeight + 'px'
    } as CSSProperties} className={cx(pulseStyles, imageStyles)} />}
            {nameArea > 0 && <div style={{
      '--margin-top': nameArea * 0.2 + 'px',
      '--height': nameArea * 0.6 + 'px'
    } as CSSProperties} className={cx(pulseStyles, nameStyles)} />}
        </div>;
});
export default Placeholder;